import React from 'react';
import { useSelector } from 'react-redux';
import MapCSpaces from '@src/components/Map/connectors/spaces';
import { getActiveMarker } from '@src/containers/Map/selectors/getActiveMarker';
import { getIsMapLayerOpen } from '@src/containers/Map/selectors/getIsMapLayerOpen';
import { useActions } from '@src/containers/Map/hooks';
import useMainFiltersVisibility from '@src/containers/Filters/hooks/useMainFiltersVisibility';
import MapSliderCDefault from '@src/components/MapSlider/connectors/default';

import MapLayer from '..';

const MapLayerCSpaces = () => {
	const activeMarker = useSelector(getActiveMarker);
	const isOpen = useSelector(getIsMapLayerOpen);
	const { setMainFiltersVisibility } = useMainFiltersVisibility();
	const { toggleMapLayer } = useActions();

	const isInViewport = (
		e,
		{ top: t, height: h } = e.getBoundingClientRect(),
	) => t <= window.innerHeight && t + h >= 0;

	React.useEffect(() => {
		return () => toggleMapLayer({ isOpen: false });
	}, [toggleMapLayer]);

	const handleClose = React.useCallback(() => {
		toggleMapLayer({ isOpen: false });
		const filtersManage = document.getElementById('tag-filter');
		if (filtersManage && isInViewport(filtersManage)) {
			setMainFiltersVisibility(true);
		}
	}, [toggleMapLayer, setMainFiltersVisibility]);

	return isOpen ? (
		<MapLayer
			Map={MapCSpaces}
			MapSliderRC={MapSliderCDefault}
			onClose={handleClose}
			sliderKey={activeMarker?.id}
			adaptive="default"
		/>
	) : null;
};

export default MapLayerCSpaces;
